import axios from 'axios';
import { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { Modal, Spinner } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { FaRegCircleCheck, FaRupeeSign, FaWhatsapp } from 'react-icons/fa6';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { BASE_URL } from '../../../insightConfig/insightConfig';
import '../../../jsx/Dashborad/dashboard.css';
import CivilButton from '../../ReusableComponent/CIVIL/CivilButton/CivilButton';
import NeetPaymentModal from './NeetPaymentModal';
// import PaymentModal from '../PaymentService/PaymentModal';
function DynamicTestSeriesHome() {
    const navigate = useNavigate();
    const location = useLocation()
    const { subject, subjectId } = location?.state;
    console.log(subject, subjectId);
    const alert = useAlert();

    const [open, setOpen] = useState(false);
    const [openPaymentProccessingModal, setPaymentProccessingModal] = useState(false);
    const email = localStorage.getItem("authtoken")
    const [testPlans, setTestPlans] = useState([])
    const [selectedSubject, setSelectedSubject] = useState({ Sn: 0, SubjectType: 'Please select subject' });
    const [selectedTest, setSelectedTest] = useState({ Sn: 1, TestCount: 5, Price: 500, Discount: 0 });
    const [tests, setTests] = useState([]);
    const [subjectSpecificData, setSubjectSpecificData] = useState({});
    const [openPaymentSuccessModal, setPaymentSuccessModal] = useState(false);
    const [transactionId, setTransactionId] = useState('');
    const enrolled = transactionId.length > 0 ? true : false;
    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const response1 = await axios.get(BASE_URL + `/neet/user/test-plans`);
                setTestPlans(response1?.data?.data);
                setSelectedTest(response1?.data?.data[0]);
                const response3 = await axios.get(BASE_URL + `/neet/user/subject-specific-data/${subjectId}`);
                setSubjectSpecificData(response3?.data?.data[0]);
            } catch (error) {
                console.log(error);
            }
        }
        fetchInitialData()
    }, []);
    useEffect(() => {
        setTests(new Array(selectedTest.TestCount).fill(1));
    }, [selectedTest.Sn])

    const testSeriesPrice = selectedTest?.Price.toLocaleString('en-IN');
    const priceAfterDiscount = selectedTest.Price - (selectedTest.Price * (selectedTest.Discount / 100))
    const payableAmount = Math.ceil(priceAfterDiscount);
    const handleEnroll = () => {
        if (email) {
            setOpen(true);
        } else {
            navigate('/login');
        }
    }
    return (
        <>
            <Helmet>
                <title>{"CUET|Seciton-IA"}</title>
                {/* <meta name="description" content={`${testSeriesData.MetaDescription}`}></meta> */}
            </Helmet>
            {/* Civil Test Page Start */}
            <div className='Dashboard-background'>
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-lg-3 col-md-12 col-sm-12 dashboardmain-left p-3'>
                            <div className='dashboardleft-background'>
                                <div className='dash1'>
                                    <img src={subjectSpecificData.Thumbnail || 'https://api.insightdelhi.com/Upload/Course/6376938789465748031 (2).png'} alt={"..."} className='dash2-img' />
                                </div>
                                <div className='dash2'>

                                    <div className="d-grid gap-2">
                                        <Link to={'/StudentDashboard'} state={{ prePath: location.pathname }} className="btn d-flex align-item-center justify-content-center btn-orange fw-bold py-2" type="button">Dashboard</Link>
                                        {/* <Link to={'/StudentDashboard'} state={{ prePath: location.pathname }} className="btn d-flex align-item-center justify-content-center btn-orange fw-bold py-3" type="button">Dashboard</Link> */}
                                        <label htmlFor="select_test" className='fw-semibold text-info text-center'>Select No. of Tests</label>
                                        <Select
                                            id='select_test'
                                            value={{ value: selectedTest, label: selectedTest.TestCount + " Tests" }}
                                            onChange={(selectedOption) => setSelectedTest(selectedOption.value)}
                                            options={testPlans?.map((item) => ({ value: item, label: item.TestCount + " Tests" }))}
                                            styles={{
                                                control: (provided) => ({
                                                    ...provided,
                                                    width: '100%',
                                                    backgroundColor: 'white',
                                                    borderColor: '#17a2b8'
                                                })
                                            }}
                                        />


                                        {
                                            selectedTest.Sn && subjectId ?
                                                <>
                                                    <button onClick={handleEnroll} className="btn btn-orange py-2" type="button">
                                                        <h6 className='text-decoration-line-through'>FEE <FaRupeeSign className='fs-6' /> {testSeriesPrice}</h6>
                                                        <h6 className=''>PAY JUST <FaRupeeSign className='fs-6' /> {payableAmount?.toLocaleString('en-IN')}</h6>
                                                        <hr className='my-1' />
                                                        <h6 className=''>DISCOUNT {selectedTest.Discount}%</h6>
                                                    </button>
                                                    <button className="btn btn-orange py-3" onClick={handleEnroll} type="button"><FaRupeeSign className='fs-6' /> {payableAmount?.toLocaleString('en-IN')} {payableAmount < 1 ? 'ENROLL FOR FREE' : 'ENROLL'}</button>
                                                </> : null
                                            // <button className="btn btn-orange py-3" type="button">ENROLLED</button>
                                        }

                                        <Link to="https://api.whatsapp.com/send?phone=91981833320" target='_blank' className="btn d-flex align-item-center justify-content-center bg-darkgreen fw-bold py-3" type="button"><FaWhatsapp className='me-1 fs-5' /> WHATSAPP 9818333201</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-9 col-md-12 col-sm-12'>
                            <CivilButton componentName={subject + "_Tests"} Neet_Subject={subject} NEET_Tests={tests} overView={subjectSpecificData.Description} enrolled={enrolled} />
                        </div>
                    </div>
                </div>
            </div>
            <Modal show={open} centered className="animate__animated animate__fadeIn mobileyoutube">
                <NeetPaymentModal setOpen={setOpen} Amount={payableAmount} TestCount={selectedTest.TestCount} SubjectType={subject} SubjectID={subjectId} setPaymentProccessingModal={setPaymentProccessingModal} setPaymentSuccessModal={setPaymentSuccessModal} setTransactionId={setTransactionId} />
            </Modal>
            <Modal show={openPaymentProccessingModal} top backdrop="static" dialogClassName="custom-modal-width">
                <div className="modal-content" style={{ backgroundColor: "#f0f8ff", padding: "2rem", borderRadius: "10px" }}>
                    <div className="modal-body" style={{ padding: "2rem" }}>
                        <div className="mb-3 d-block text-center">
                            <Spinner
                                animation="border"
                                className="mt-5 mb-3"
                                size="xl"
                                style={{ width: "200px", height: "200px", color: "#ff2f00" }}

                            />
                            <h5
                                className="modal-title mb-5"
                                id="exampleModalLabel"
                                style={{ color: "#17a2b8", fontFamily: "Arial, sans-serif" }}
                            >
                                Saving Order Details. This may take a moment...
                            </h5>
                        </div>
                    </div>
                </div>
            </Modal>
            <Modal show={openPaymentSuccessModal} top backdrop="static" dialogClassName="" size="lg" centered>
                <div className="" style={{ backgroundColor: "#f0f8ff", padding: "2rem", borderRadius: "10px" }}>
                    <div className='p-5 py-3 d-flex justify-content-center align-items-center' >
                        <div className='text-black text-center'>
                            <FaRegCircleCheck className='text-orange' style={{ fontSize: "15vmax" }} />
                            <h1 className='py-2 fw-bold text-success'>Payment Successful</h1>
                            <h4 className='text-info'>Your order has been placed Successfully</h4>
                            <h6 > <span style={{ fontWeight: "700" }}>Course</span> : NEET - {subject}</h6>
                            <h6 ><span style={{ fontWeight: "700" }}>Payment ID</span> : {transactionId}</h6>

                            {/* <h6>Payment ID:</h6> */}
                            {/* <h6>{paymentdetail[0].TranscationID}</h6> */}
                            <div className='p-3 d-flex justify-content-center'>
                                <button onClick={() => setPaymentSuccessModal(false)} style={{ textDecoration: "none" }} className='bg-orange text-white py-2 rounded-pill fs-6 px-4' >
                                    done
                                </button>
                                {/* <Link to={`/cuet/${ExamType.toLowerCase()}`} state={{ enrolled: true }} style={{ textDecoration: "none" }} className='bg-orange text-white py-2 rounded-pill fs-6 px-4' >
                                                                done
                                                            </Link> */}
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
            {/* Civil Test Page End */}
        </>
    )
}

export default DynamicTestSeriesHome;



